namespace Areas.Dialogs.TimeEntryReversal {
    "use strict";

    let employeeId: number;
    let timeEntries: any;

    export class TimeEntryReversalDialog extends Areas.BaseDialog {
        timeEntries: any;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("TimeEntryReversal", closeHandler, parameters, () => {
                employeeId = parameters.employeeId;
                timeEntries = parameters.timeEntries;
            })
        }

        protected ok = (e: any) => {
            const reversalForm = $("#ReversalForm").dxForm("instance");

            const result: any = reversalForm.validate();

            if (result.isValid) {
                const formData = reversalForm.option("formData");

                const data = JSON.stringify({
                    employeeId: employeeId,
                    comment: formData.comment,
                    timeEntries: timeEntries
                });

                const url = "/Dialog/TimeEntryReversal/Put";
                sendRequest(url, data, "PUT", () => this.close(DialogResult.Ok, null));
            }
       }
    }

    export function getEmployeeId() {
        return employeeId;
    }
    
}